export const defaultFields = [
	{ key: 'VENDOR_ID_ARIBA', label: 'Ariba', sortable: true, thClass: 'bg-subhead', thStyle: { verticalAlign: 'middle' }, tdClass : 'column-hover-button'},
	{ key: 'VENDOR_ID_SAPBC', label: 'SAP BC', sortable: true, thClass: 'bg-subhead', thStyle: { verticalAlign: 'middle' } },
	{ key: 'VENDOR_ID_SAPGEMS', label: 'SAP GEMS', sortable: true, thClass: 'bg-subhead', thStyle: { verticalAlign: 'middle' } },
	{ key: 'VENDOR_ID_SAPBKES', label: 'SAP BKES', sortable: true, thClass: 'bg-subhead', thStyle: { verticalAlign: 'middle' } },
	{ key: 'VENDOR_NAME', label: 'Vendor Name', sortable: true, thClass: 'bg-subhead', thStyle: { borderTop: 0, verticalAlign: 'middle' } },
	{ key: 'APPROVED_COMMODITIES', label: 'Commodities', sortable: true, thClass: 'bg-subhead', thStyle: { borderTop: 0, verticalAlign: 'middle' } },
	{ 
		key: 'ORGANIZATION', 
		label: 'Organization', 
		sortable: true, 
		sortByFormatted : true,
		formatter : (value, key, item) => {
			// {{item.item.ORGANIZATION_BCE  == 'Yes' ? 'BCE' : null}} {{item.item.ORGANIZATION_GEMS  == 'Yes' ? 'GEMS' : null}} {{item.item.ORGANIZATION_BKES  == 'Yes' ? 'BKES' : null}
			let org = []
			if(item && item.VENDOR_ID_SAPBC) org.push('BCE')
			if(item && item.VENDOR_ID_SAPGEMS) org.push('GEMS')
			if(item && item.VENDOR_ID_SAPBKES) org.push('BKES')

			if(org.length > 0){
				return org.join(',')
			}
			return
		},
		thClass: 'bg-subhead', 
		thStyle: { verticalAlign: 'middle' } 
	},
	{ 
		key: 'TOTAL_PO_RELEASED', 
		label: 'Total PO Released', 
		sortable: true, 
		sortByFormatted : true,
		formatter : (value, key,item) => {
			if(item.po && item.po.length > 0){
				return item.po.length
			}
			return 0
		},
		thClass: 'bg-subhead', 
		thStyle: { borderTop: 0, verticalAlign: 'middle' }, 
		tdClass : 'column-hover-button'
	},
	{ key: 'LEGAL_DOCUMENT', label: 'Legal Document', sortable: true, thClass: 'bg-subhead', thStyle: { borderTop: 0, verticalAlign: 'middle' } },
	{ 
		key: 'TOTAL_EVENT', 
		label: 'Total Event', 
		sortable: true, 
		sortByFormatted : true,
		formatter : (value, key, item) => {
			if(item.EVENT && item.EVENT.length > 0){
				return item.EVENT.length
			}
			return 0
		},
		thClass: 'bg-subhead', 
		thStyle: { borderTop: 0, verticalAlign: 'middle' } 
	},
	{ key: 'SCORE_FOR_K3L_PREQUALIFICATION', label: 'K3L Assesment', sortable: true, thClass: 'bg-subhead', thStyle: { borderTop: 0, verticalAlign: 'middle' } },
]

export const filterCategory = [
	{
		label: 'VENDOR_ID_ARIBA',
		defaultValue: null,
		field_name: 'ARIBA',
		type: 'input',
		placeholder: 'VENDOR ID ARIBA',
		role : 1
	},
	{
		label: 'VENDOR_ID_SAPBC',
		defaultValue: null,
		field_name: 'SAP BC',
		type: 'input',
		placeholder: 'VENDOR ID SAP BC',
		role : 1
	},
	{
		label: 'VENDOR_ID_SAPGEMS',
		defaultValue: null,
		field_name: 'SAP GEMS',
		type: 'input',
		placeholder: 'VENDOR ID SAP GEMS',
		role : 1
	},
	{
		label: 'VENDOR_ID_SAPBKES',
		defaultValue: null,
		field_name: 'SAP BKES',
		type: 'input',
		placeholder: 'VENDOR ID SAP BKES',
		role : 1
	},
	{
		label: 'COMMODITIES_UNSPSC',
		defaultValue: null,
		field_name: 'Commodities UNSPSC',
		type: 'input',
		placeholder: 'COMMODITIES UNSPSC',
		role : 1
	},
	{
		label: 'K3L_ASSESSMENT',
		defaultValue: null,
		field_name: 'K3L Assessment',
		type: 'input',
		placeholder: 'K3L ASSESSMENT',
		role : 1
	},
	{
		label: 'RISK_CATEGORY',
		defaultValue: null,
		field_name: 'Risk Category',
		type: 'input',
		placeholder: 'RISK CATEGORY',
		role : 1
	},
	{
		label: 'K3L_PREQUALIFICATION_END_DATE',
		defaultValue: null,
		field_name: 'K3L Prequalification End Date',
		type: 'input',
		placeholder: 'K3L Prequalification End Date',
		role : 1
	},
	{
		label: 'K3L_REMAINING_DAYS',
		defaultValue: null,
		field_name: 'K3L Remaining Expired Days',
		type: 'input',
		placeholder: '',
		role : 1
	},
	{
		label: 'SPM_SCORING',
		defaultValue: null,
		field_name: 'SPM Scoring',
		type: 'input',
		placeholder: 'SPM Scoring',
		role : 1
	},
	{
		label: 'ORGANIZATION_BCE',
		defaultValue: null,
		field_name: 'Organization BCE',
		type: 'input',
		placeholder: 'Organization BCE',
		role : 1
	},
	{
		label: 'ORGANIZATION_GEMS',
		defaultValue: null,
		field_name: 'Organization GEMS',
		type: 'input',
		placeholder: 'Organization GEMS',
		role : 1
	},
	{
		label: 'ORGANIZATION_BKES',
		defaultValue: null,
		field_name: 'Organization BKES',
		type: 'input',
		placeholder: 'Organization BKES',
		role : 1
	},
	{
		label: 'VENDOR_NAME',
		defaultValue: null,
		field_name: 'Vendor Name',
		type: 'input',
		placeholder: 'Vendor Name',
		role : 1
	},
	{
		label: 'APPROVED_COMMODITIES',
		defaultValue: null,
		field_name: 'Approved Commodities',
		type: 'input',
		placeholder: 'Approved Commodities',
		role : 1
	},
	{
		label: 'CITY',
		defaultValue: null,
		field_name: 'City',
		type: 'input',
		placeholder: 'City',
		role : 1
	},
	{
		label: 'PROVINCE',
		defaultValue: null,
		field_name: 'Province',
		type: 'input',
		placeholder: 'Province',
		role : 1
	},
	{
		label: 'COUNTRY',
		defaultValue: null,
		field_name: 'Country',
		type: 'input',
		placeholder: 'Country',
		role : 1
	},
	{
		label: 'PO_DATE',
		defaultValue: null,
		field_name: 'PO Date',
		type: 'input',
		placeholder: 'PO Date',
		role : 1
	},
	{
		label: 'PERIOD_FROM',
		defaultValue: null,
		field_name: 'Period From',
		type: 'input',
		placeholder: 'Period From',
		role : 1
	},
	{
		label: 'PERIOD_TO',
		defaultValue: null,
		field_name: 'Period To',
		type: 'input',
		placeholder: 'Period To',
		role : 1
	},
	{
		label: 'CSI_SCORING',
		defaultValue: null,
		field_name: 'CSI Scoring',
		type: 'input',
		placeholder: 'CSI Scoring',
		role : 2
	},
	{
		label: 'CSI_FINAL_ADJ',
		defaultValue: null,
		field_name: 'CSI Final Adj',
		type: 'input',
		placeholder: 'CSI Final Adj',
		role : 2
	},
	{
		label: 'ADDRESS',
		defaultValue: null,
		field_name: 'Address',
		type: 'input',
		placeholder: 'Address',
		role : 2
	},
	{
		label: 'STATUS_SUPPLIER',
		defaultValue: null,
		field_name: 'Status Supplier',
		type: 'input',
		placeholder: 'Status Supplier',
		role : 2
	},
	{
		label: 'TOTAL_PO_RELEASED',
		defaultValue: null,
		field_name: 'Total PO Released',
		type: 'input',
		placeholder: 'Total PO Released',
		role : 2
	},
	{
		label: 'PO_VALUE',
		defaultValue: null,
		field_name: 'PO Value',
		type: 'input',
		placeholder: 'PO Value',
		role : 2
	},
	{
		label: 'EVENT_AWARDED',
		defaultValue: null,
		field_name: 'Event Awarded',
		type: 'input',
		placeholder: 'Event Awarded',
		role : 2
	},
	{
		label: 'EVENT_PARTICIPATED',
		defaultValue: null,
		field_name: 'Event Participated',
		type: 'input',
		placeholder: 'Event Participated',
		role : 2
	},
	{
		label: 'PO_TYPE',
		defaultValue: null,
		field_name: 'PO Type',
		type: 'input',
		placeholder: 'PO Type',
		role : 2
	},
	{
		label: 'SPM_TOTAL_AVG_SCORE',
		defaultValue: null,
		field_name: 'SPM Total Average Score',
		type: 'input',
		placeholder: 'SPM Total Average Score',
		role : 3
	},
	{
		label: 'SPM_PERFORMANCE_PERIOD',
		defaultValue: null,
		field_name: 'SPM Performance Period',
		type: 'input',
		placeholder: 'SPM Performance Period',
		role : 3
	},
	{
		label: 'VENDOR_CATEGORY',
		defaultValue: null,
		field_name: 'Vendor Category',
		type: 'input',
		placeholder: 'Vendor Category',
		role : 3
	},
	{
		label: 'LEGAL_DOCUMENT_STATUS',
		defaultValue: null,
		field_name: 'Legal Document Status',
		type: 'input',
		placeholder: 'Legal Document Status',
		role : 3
	},
	{
		label: 'LEGAL_DOCUMENT_EXPIRED_DATE',
		defaultValue: null,
		field_name: 'Legal Document Expired Date',
		type: 'input',
		placeholder: 'Legal Document Expired Date',
		role : 3
	},
	{
		label: 'HASIL_FINANSIAL_ASSESSMENT',
		defaultValue: null,
		field_name: 'Hasil Finansial Assessment',
		type: 'input',
		placeholder: 'Hasil Finansial Assessment',
		role : 3
	},
	{
		label: 'BIDANG_USAHA',
		defaultValue: null,
		field_name: 'Bidang Usaha',
		type: 'input',
		placeholder: 'Bidang Usaha',
		role : 3
	},
	{
		label: 'IUJP',
		defaultValue: null,
		field_name: 'IUJP',
		type: 'input',
		placeholder: 'UIJP',
		role : 3
	},
]
